export type IframeMessageKey = 'dgtalGuideFrameHeight' | 'dgtalGuideScrollTop';

export function SendMessageToIFrame(message: Partial<Record<IframeMessageKey, any>>) {
    window.parent.postMessage(message, '*');
}
